import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const lawnMowerBrowseQueryOptions = queryOptions({
  queryKey: ["lawn-mowers-browse"],
  queryFn: async () => {
    const { data, error } = await supabase.from("lawn_mowers").select("*").eq("status", "published").order("rating", { ascending: false });
    if (error) throw error;
    return data ?? [];
  },
});

export const lawnMowerAffiliateBrowseQueryOptions = queryOptions({
  queryKey: ["lawn-mower-affiliates-browse"],
  queryFn: async () => {
    const { data, error } = await supabase.from("lawn_mower_affiliates").select("*").order("price_gbp", { ascending: true });
    if (error) throw error;
    return data ?? [];
  },
});